import { IDENTITIES_KEYS, VALUES_TYPES } from '../types';
import { isObject } from './utils';
/**
 * Validation map. Specifify validation callback or array of supported keys inside identity
 */
const whiteList = {
    [IDENTITIES_KEYS.sid]: (value) => typeof value === VALUES_TYPES.string,
    [IDENTITIES_KEYS.udid]: (value) => typeof value === VALUES_TYPES.string,
    [IDENTITIES_KEYS.secid]: (value) => typeof value === VALUES_TYPES.string,
    [IDENTITIES_KEYS.eid]: (value) => typeof value === VALUES_TYPES.string,
    [IDENTITIES_KEYS.login]: ['state', 'uid', 'premium', 'advert_uid', 'said', 'others'],
    [IDENTITIES_KEYS.consent]: ['consentString', 'name', 'version', 'purposeOne'],
    [IDENTITIES_KEYS.id5]: (value) => typeof value === VALUES_TYPES.string,
};
/**
 * Validate / include just allowed keys in identity object
 */
const _validateIdentityKeys = (identityValue, whiteListItem) => {
    return whiteListItem.reduce((accSingleIdentity, item) => {
        const identityValueKey = identityValue[item];
        if (identityValueKey !== undefined) {
            accSingleIdentity[item] = identityValueKey;
        }
        return accSingleIdentity;
    }, {});
};
/**
 * Trim not whitelisted identities values
 */
export const includeOnlyWhitelisted = (identities) => {
    return Object.keys(identities).reduce((accIdentities, key) => {
        const identityKey = key;
        const identityValue = identities[identityKey];
        const whiteListItem = whiteList[identityKey];
        if (whiteListItem !== undefined) {
            if (Array.isArray(whiteListItem) && isObject(identityValue)) {
                // validateby whitelist 1. level keys
                accIdentities[identityKey] = _validateIdentityKeys(identityValue, whiteListItem);
            }
            else if (typeof whiteListItem === 'function' && whiteListItem(identityValue)) {
                // validate by whitelist function
                accIdentities[identityKey] = identityValue;
            }
        }
        return accIdentities;
    }, {});
};
